import React from 'react';

export const GitLogo = () => {
  return (
    <svg className="stack-icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <title>Logo Git</title>
      <g id="ed14bfe0-deb7-41e5-80b1-4f7bed74feff" data-name="Layer 2">
        <g id="acaaffcd-b8a7-4a48-916a-4b4f963771d9" data-name="Layer 1">
          <circle cx="50" cy="50" r="50" fill="#ebebeb" />
          <path
            d="M77.6,47.4,52.7,22.5a3.6,3.6,0,0,0-5.2,0l-5.2,5.2,6.6,6.5a4.3,4.3,0,0,1,4.5,1.1,4.4,4.4,0,0,1,1,4.5l6.3,6.3a4.4,4.4,0,0,1,4.6,1.1,4.3,4.3,0,0,1,0,6.1,4.2,4.2,0,0,1-6.2,0,4.3,4.3,0,0,1-1-4.7l-5.9-5.9V58.2l1.2.8a4.4,4.4,0,1,1-6.2,0,4.2,4.2,0,0,1,1.4-.9V42.4a4.2,4.2,0,0,1-1.4-.9,4.3,4.3,0,0,1-.9-4.8l-6.5-6.5L22.7,47.3a3.6,3.6,0,0,0,0,5.2L47.6,77.4a3.6,3.6,0,0,0,5.2,0L77.6,52.6A3.6,3.6,0,0,0,77.6,47.4Z"
            fill="#f05133"
          />
        </g>
      </g>
    </svg>
  );
};
